import { render, staticRenderFns } from "./propstack.vue?vue&type=template&id=931fcac6&"
import script from "./propstack.vue?vue&type=script&lang=js&"
export * from "./propstack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports